import type { Middleware } from "@reduxjs/toolkit"
import { clearTokens, setTokens } from "@/lib/api/client"
import type { RootState } from "../index"

/**
 * Middleware to sync tokens between Redux and localStorage
 * localStorage is the source of truth (axios interceptor updates it directly)
 */
export const tokenSyncMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action)

    if (
      typeof action === "object" &&
      action !== null &&
      "type" in action &&
      typeof action.type === "string"
    ) {
      const actionType = action.type

      // On REHYDRATE: DON'T overwrite localStorage - it may have newer tokens from refresh
      // localStorage is the source of truth
      if (actionType === "persist/REHYDRATE") {
        return result
      }

      // On login success: sync tokens to localStorage
      if (actionType === "auth/loginUser/fulfilled") {
        const state = store.getState() as RootState
        const { token, refreshToken } = state.auth

        if (token) {
          setTokens(token, refreshToken || undefined)
        }
        return result
      }

      // On explicit logout/clear: clear localStorage
      if (
        actionType === "auth/clearAuth" ||
        actionType === "auth/logoutUser/fulfilled"
      ) {
        clearTokens()
      }
    }

    return result
  }
